import api from "./api";

const UserPlanSubscriptionAPI = {
    getByUserId: (userId) => api.get(`/user-plan-subscriptions/user/${userId}`),
    getById: (id) => api.get(`/user-plan-subscriptions/details/${id}`),
 };

export default UserPlanSubscriptionAPI;